module.exports = __webpack_public_path__ + "img/placeholder2.0ca97b77.png";